import ApiService from "./ApiService";

class BreadcrumbsService extends ApiService{
    constructor() {
        super();
        this._singleUrl = '/breadcrumbs/single';
    }

    getBreadcrumbs(params) {
        return this.postResource(
            this._singleUrl,
            params || {},
            {...this.getLangHeader()}
        );
    }
}

export default new BreadcrumbsService();
